import { useState } from "react";
import { MenuItemProps, MenuItems } from "react-migration/components/ContextMenu/MenuItems";
import { Icon, IconProps } from "react-migration/components/Icon";
import { Button } from "react-migration/components/Button/Button";

export const UserMenuMobile = ({
  menuItems,
  trigger,
  triggerIconProps = {
    icon: "icon-lt-more-2-line",
    size: "lg",
    extraClasses: "block text-xl w-full",
    cursor: "pointer",
  },
}: {
  menuItems: MenuItemProps[];
  trigger: React.ReactNode;
  triggerIconProps?: IconProps;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="w-full flex items-center justify-center *:first:w-full">
        <Button variant="clear" className="flex items-center justify-center p-0!" onClick={() => setOpen(!open)}>
          {open ? (
            <Icon icon="icon-lt-close-line" size="lg" extraClasses="block text-xl pt-2" />
          ) : trigger ? (
            trigger
          ) : (
            <Icon {...triggerIconProps} />
          )}
        </Button>
      </div>
      {open && (
        <div className="fixed top-0 left-0 z-26 flex flex-col py-1 overflow-hidden bg-white w-full h-[calc(100dvh-var(--navbar-mobile-height))]">
          <MenuItems items={menuItems} setMobileDrawer={setOpen} noBorder={true} />
        </div>
      )}
    </>
  );
};
